import styled from 'styled-components';
import { BRAND_COLORS } from 'brand-guidelines/colors';

export const StyledModalProgressBar = styled.div`
  display: flex;
  margin-bottom: 30px;
  border-radius: 4px;
  overflow: hidden;
  padding: 0;
`;

export const ProgressBarItem = styled.div`
  background-color: ${props => props.color};
  color: ${BRAND_COLORS.white};
  font-weight: 400;
  padding: 10px;
  padding-right: 0;
  position: relative;
  text-align: center;
  width: ${props => props.width};

  &::after {
    border-bottom: 50px solid transparent;
    border-left: 25px solid ${props => props.color};
    border-top: 50px solid transparent;
    content: ' ';
    display: block;
    height: 0;
    left: 100%;
    margin-top: -50px;
    margin-left: -17px;
    position: absolute;
    top: 50%;
    width: 0;
    z-index: 11;
  }

  &::before {
    border-bottom: 50px solid transparent;
    border-left: 25px solid white;
    border-top: 50px solid transparent;
    content: ' ';
    display: block;
    height: 0;
    left: 100%;
    margin-top: -50px;
    margin-left: -14px;
    position: absolute;
    top: 50%;
    width: 0;
    z-index: 10;
  }

  &:first-child {
    padding-left: 5px;
  }

  &:last-child {
    &::before,
    &::after {
      display: none;
    }
  }
`;
